import React, { Component } from "react";
import LineItemDataStore from "../../../../Flux/Stores/LineItemDataStore";
import BookFiltersStore from "../../../../Flux/Stores/BookFiltersStore";
import { fetchOnlyLineItems, pushLineItemsToDV360, updateLineItemsSyncStatus } from "../../../../Flux/Actions/LineItemActions";
import { fetchOnlyInsertionOrders } from "../../../../Flux/Actions/InsertionOrderActions";
import MasterCampaignsStore from "../../../../Flux/Stores/MasterCampaignsStore";
import FindReplaceModal from "../../../Modals/FindReplaceModal";
import NewLineItem from "../../../Modals/NewLineItem";
import EditLineItem from "../../../Modals/EditLineItem";
import DeleteLineItem from "../../../Modals/DeletePlatformModal";
import DuplicatePlatformModal from "../../../Modals/DuplicatePlatformModal";
import MultiplierModal from "../../../Modals/MultiplierModal";
import LoadingIcon from "../../../../Components/LoadingSpinner";
import { TOOLBAR_MODE, EDIT_BUTTON_LOCATION } from "@acadia-ui/toolbar";
import { COLUMNS } from "../../../../Components/ShowHideColumns";
import WorkbookStore from "../../../../Flux/Stores/WorkbookStore";
import Table from "../../../../Components/Table/Table";
import _ from "lodash";

import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Textbox from "@acadia-ui/textbox";
import Modal from "@acadia-ui/modal";
import { retryAtInterval } from "../retryAtInterval";
import applyFindReplaceToTable from "../applyFindReplaceToTable";
import FullFiltersSidesheet, { fullFilterAlgorithm } from "../FullFiltersSidesheet";

import TraffickingRequestModal from "../../../Modals/TraffickingRequestModal";
import TraffickingDataStore from "../../../../Flux/Stores/TraffickingDataStore";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";
import { draftHLISelected } from "../../../../Helpers/ActionHelpers";

class LegacyLineItemView extends Component {
	constructor() {
		super();
		this.state = {
			isHidden: true,
			lineItemsToDelete: [],
			readOnly: true,
			selectedCount: 0,
			selectedRows: [],
			success: false,
			successMessage: null,
			delete: false,
			singleSelected: false,
			multipleSelected: false,
			draftSelected: false,
			searchValue: "",
			filteredIO: null,
			advancedFilter: false,
			displayFilter: false,
			extraColumns: [],
			dv360APIEnabled: false,
			displayDV360StatusFilter: false,
			search: ""
		};

		this.dataTableApi = React.createRef();

		this.filterChoices = BookFiltersStore.getChoicesState();
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
	}

	getLineItems = () => {
		const lineItemData = LineItemDataStore.getData();
		let siteOptions = null;
		if (LineItemDataStore.getConfig().LineItemData !== undefined) {
			LineItemDataStore.getConfig().LineItemData.forEach((option) => {
				if (option.Name === "PlatformSiteID") {
					siteOptions = option.Options;
				}
			});
		}
		if (siteOptions !== null) {
			lineItemData.forEach((lineItem) => {
				if (lineItem.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (lineItem.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						lineItem.PlatformSiteID = platformName;
					}
				}
			});
		}
		this.setState({
			lineItemConfig: LineItemDataStore.getConfig(),
			lineItemData: LineItemDataStore.getData(),
			loading: false,
			isHidden: false
		});
	};

	componentDidMount = () => {
		this.getLineItems();
		this.setEnabledColumns();

		if (LineItemDataStore.getFilterIO() !== null && LineItemDataStore.getFilterIOID() !== null) {
			this.filterIO();
		}

		LineItemDataStore.on("lineitems_success", this.gridChanged);
		LineItemDataStore.on("lineitems_edit_success", this.gridChanged);
		LineItemDataStore.on("create_and_add_lineitems_success", this.gridChanged);
		LineItemDataStore.on("lineitem_deleted", this.lineItemDeleted);
		LineItemDataStore.on("only_LI_config_fetched", this.configChanged);
		LineItemDataStore.on("filtered_IO", this.filterIO);
		LineItemDataStore.on("openLineItemModal", this.parentIOCreated);
		LineItemDataStore.on("sync_status_updated", () => this.gridChanged(true));
		BookFiltersStore.on("fetchSyncStatusesSuccess", this.toggleDV360API);
		BookFiltersStore.on("fetchSyncStatusesFailure", this.toggleDV360API);
		WorkbookStore.on("enabled_columns_fetched", this.setEnabledColumns);
		TraffickingDataStore.on("submit_trafficking_success", this.submitTraffickingSuccess);

		this.toggleDV360API();
	};

	componentWillUnmount = () => {
		LineItemDataStore.removeListener("lineitems_success", this.gridChanged);
		LineItemDataStore.removeListener("lineitems_edit_success", this.gridChanged);
		LineItemDataStore.removeListener("create_and_add_lineitems_success", this.gridChanged);
		LineItemDataStore.removeListener("lineitem_deleted", this.lineItemDeleted);
		LineItemDataStore.removeListener("only_LI_config_fetched", this.configChanged);
		LineItemDataStore.removeListener("filtered_IO", this.filterIO);
		LineItemDataStore.removeListener("openLineItemModal", this.parentIOCreated);
		LineItemDataStore.removeListener("sync_status_updated", () => this.gridChanged(true));
		BookFiltersStore.removeListener("fetchSyncStatusesSuccess", this.toggleDV360API);
		BookFiltersStore.removeListener("fetchSyncStatusesFailure", this.toggleDV360API);
		WorkbookStore.removeListener("enabled_columns_fetched", this.setEnabledColumns);
		TraffickingDataStore.removeListener("submit_trafficking_success", this.submitTraffickingSuccess);
	};

	componentDidUpdate = (prevProps, prevState) => {
		if (!_.isEqual(prevState.extraColumns, this.state.extraColumns)) {
			// force rerender of table
			this.setState({ isHidden: true }, () => {
				this.setState({ isHidden: false });
			});
		}
	};

	toggleDV360API = () => {
		const statuses = BookFiltersStore.getSyncStatuses();
		if (statuses) {
			const { SyncStatus } = statuses.find(({ MasterPlatformID }) => MasterPlatformID === 2);
			const validStatusIDs = [3, 6];
			let platformPKExists = false;
			if (this.props.campaignMetaData?.PlatformCampaignPK) {
				try {
					platformPKExists = JSON.parse(this.props.campaignMetaData.PlatformCampaignPK).some((platform) => {
						return platform.MasterPlatformID === 2 && platform.PlatformPK;
					});
				} catch {
					console.log("PlatformCampaignPK is not in JSON format");
				}
			}
			this.setState(
				{
					dv360APIEnabled: SyncStatus && validStatusIDs.includes(this.props.campaignMetaData.ExternalSystemStatusID) && platformPKExists,
					displayDV360StatusFilter: SyncStatus
				},
				() => {
					this.setEnabledColumns();
				}
			);
		}
	};

	setEnabledColumns = () => {
		const JIRAStatus = WorkbookStore.getIsTrafficEnabled();
		const syncStatus = BookFiltersStore?.getSyncStatuses()?.find(({ MasterPlatformID }) => MasterPlatformID == this.props?.campaignMetaData?.PlatformID)?.SyncStatus;

		const enabledColumns = syncStatus ? COLUMNS.DV360 : [];

		if (JIRAStatus) {
			enabledColumns.push(...COLUMNS.TRAFFIC_MANAGER);
			enabledColumns.push(COLUMNS.DO_NOT_USE);
		}

		enabledColumns.push(COLUMNS.IsDraft);

		const auditLevel = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "LineItem")?.AuditLevelID;
		const Preferences = WorkbookStore.getEnabledColumns()?.find(({ HierarchyLevelID }) => HierarchyLevelID == auditLevel)?.Preferences;
		const parsedPreferences = Preferences ? JSON.parse(Preferences) : null;

		if (parsedPreferences && parsedPreferences instanceof Object) {
			this.setState({
				extraColumns: enabledColumns.map(({ id, name, selected }) => ({
					id,
					name,
					selected: parsedPreferences?.[id] ?? selected
				}))
			});
		} else {
			this.setState({ extraColumns: enabledColumns });
		}
	};

	parentIOCreated = () => {
		this.newLineItemModal.parentChanged();
	};

	filterIO = () => {
		setTimeout(() => {
			this.setState({
				lineItemData: LineItemDataStore.getFilteredData(),
				filteredIO: LineItemDataStore.getFilterIO(),
				searchValue: "",
				success: false,
				successMessage: null
			});

			if (LineItemDataStore.getFilterIO()) {
				const parentKey = this.state.lineItemConfig?.ParentData?.find((key) => {
					return key.Name === "ParentDescription";
				});
				const parentOption = parentKey?.Options?.find((option) => {
					return option.OptionID === LineItemDataStore.getFilterIOID();
				});
				if (parentOption) {
					const newFilterOptions = [{ dataKey: parentKey, dataValue: [{ ...parentOption, value: parentOption.OptionID, label: parentOption.OptionLabel }] }];
					this.setState({ filterOptions: newFilterOptions });
					this.dataTableApi?.current?.toolbarApi?.current?.setFilterValues({ 0: newFilterOptions });
					LineItemDataStore.resetSelectedIO();
					LineItemDataStore.resetSelectedIOID();
				}
			}
		}, 0);
	};

	lineItemDeleted = () => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		let IOAuditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "InsertionOrder") {
				IOAuditLevelChoice = auditLevel;
			}
		});

		// const IOchoices = JSON.parse(JSON.stringify(this.filterChoices));
		// if (IOAuditLevelChoice !== null) {
		// 	IOchoices.auditlevel = IOAuditLevelChoice;
		// 	fetchOnlyInsertionOrders(IOchoices, this.parentCampaignUniqueID);
		// }
		this.props.updateCounts();
		this.gridChanged();
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Line item deleted successfully." timed={5000} />);
	};

	openModal = () => {
		this.newLineItemModal.triggerOpenClose();
	};

	setSelectedRow = (callback) => {
		const selectedLine = this.state.selectedRows[0];
		const dataArr = {};
		Object.keys(selectedLine).forEach((key) => {
			if ((key === "EndDate" || key === "StartDate") && selectedLine[key] !== "") {
				dataArr[key] = this.formatDate(selectedLine[key]);
			} else if (key === "Cost" || key === "Budget") {
				dataArr[key] = selectedLine[key].replace(/[^\d.-]/g, "");
			} else if (key !== "UniqueID" && key !== "LineItemName") {
				dataArr[key] = selectedLine[key];
			}
		});
		this.setState({ selectedRow: dataArr }, () => {
			callback?.();
		});
	};

	editLineItem = () => {
		this.setSelectedRow(() => {
			this.editLineItemModal.triggerOpenClose();
		});
	};

	deleteLineItem = () => {
		const selectedUniqueIDs = this.state.selectedRows.map((row) => {
			return row.UniqueID;
		});
		const selectedLines = JSON.parse(JSON.stringify(LineItemDataStore.getData()))
			.map((row, index) => {
				row.Row = index;
				return row;
			})
			.filter((row) => {
				return selectedUniqueIDs.includes(row.UniqueID);
			});
		this.setState({ lineItemsToDelete: selectedLines }, () => {
			this.deleteLineItemModal.triggerOpenClose();
		});
	};

	formatDate = (date) => {
		const d = new Date(date);
		let month = String(d.getMonth() + 1);
		let day = String(d.getDate());
		const year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	};

	duplicateLineItemData = () => {
		this.setSelectedRow(() => {
			this.duplicateLineItem.triggerOpenClose();
		});
	};

	refetchData = (callback) => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		const IOchoices = JSON.parse(JSON.stringify(this.filterChoices));
		let auditLevelChoice = null;
		let IOAuditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "LineItem") {
				auditLevelChoice = auditLevel;
			}
			if (auditLevel.label === "InsertionOrder") {
				IOAuditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			IOchoices.auditlevel = IOAuditLevelChoice;
			this.setState({ readOnly: true, searchValue: "", advancedFilter: false, displayFilter: false });
			this.props.updateCounts().then(() => {
				this.gridChanged();
				callback?.();
				// fetchOnlyInsertionOrders(IOchoices, this.parentCampaignUniqueID);
			});
		}
	};

	gridChanged = (loading = false) => {
		const packData = LineItemDataStore.getData();
		let siteOptions = null;
		LineItemDataStore.getConfig().LineItemData.forEach((option) => {
			if (option.Name === "PlatformSiteID") {
				siteOptions = option.Options;
			}
		});
		if (siteOptions !== null) {
			packData.forEach((pack) => {
				if (pack.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (pack.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						pack.PlatformSiteID = platformName;
					}
				}
			});
		}

		let preparredData;

		if (Object.keys(this.state.filterOptions ?? {})?.length > 0) {
			this?.dataTableApi?.current?.dataProvider?.update?.(packData);
			preparredData = fullFilterAlgorithm({
				handleFilter: () => {},
				config: LineItemDataStore.getConfig(),
				data: LineItemDataStore.getData(),
				dataTableApi: this.dataTableApi,
				filterOptions: this.state.filterOptions,
				hierarchyLevel: "LineItem"
			});
		} else {
			preparredData = LineItemDataStore.getData();
		}

		// fix improper date format post addition of new line items
		preparredData = preparredData?.map((lineItem) => ({
			...lineItem,
			StartDate: lineItem?.StartDate?.split?.(" ")?.[0] || StartDate,
			EndDate: lineItem?.EndDate?.split?.(" ")?.[0] || EndDate
		}));

		this.setState({ lineItemData: preparredData, loading }, () => {
			if (LineItemDataStore.getFilterIO() !== null && LineItemDataStore.getFilterIOID() !== null) {
				const filteredData = this.state.lineItemData.filter((lineItem) => {
					return lineItem.InsertionOrderID === LineItemDataStore.getFilterIOID();
				});
				this.setState({ lineItemData: filteredData });
			}
			this.props.updateMetaData();
		});
	};

	configChanged = () => {
		this.setState({ lineItemConfig: LineItemDataStore.getConfig() });
	};

	unlockSheet = () => {
		this.setState({
			readOnly: !this.state.readOnly,
			success: false,
			successMessage: null,
			delete: false
		});
	};

	lockSheet = () => {
		this.setState({
			readOnly: true,
			success: true,
			successMessage: null,
			delete: false
		});
	};

	numberSelected = (row, chk, selectAll = false) => {
		let newSelectedRows = this.state.selectedRows;
		let draftSelected = false;
		if (!selectAll) {
			if (chk) {
				newSelectedRows.push(row);
				if (row.IsDraft === "True") {
					draftSelected = true;
				}
			} else {
				newSelectedRows = newSelectedRows.filter((selectedRow) => {
					return selectedRow.UniqueID != row.UniqueID;
				});
			}
		} else {
			newSelectedRows = row;
			if (
				row.find((data) => {
					return data.IsDraft === "True";
				})
			) {
				draftSelected = true;
			}
		}
		this.setState({
			selectedRows: newSelectedRows,
			selectedCount: newSelectedRows.length,
			success: false,
			delete: false,
			singleSelected: newSelectedRows.length === 1,
			multipleSelected: newSelectedRows.length > 1,
			draftSelected
		});
	};

	openMultiplierModal = () => {
		this.multiplierModal.triggerOpenClose();
	};

	returnSearchedValues = (searchTerm) => {
		const searchableFields = [];
		const filteredData = [];
		const configKeys = Object.keys(this.state.lineItemConfig);
		configKeys.forEach((bucket) => {
			if (Array.isArray(this.state.lineItemConfig[bucket])) {
				this.state.lineItemConfig[bucket].forEach((field) => {
					if (field.IsSummarizedHeader === true) {
						searchableFields.push(field.Name);
					}
				});
			}
		});
		this.state.lineItemData.forEach((data) => {
			let matchFound = false;
			for (const field of searchableFields) {
				if (data[field]) {
					if (data[field].toLowerCase().includes(searchTerm.toLowerCase())) {
						filteredData.push(data);
						matchFound = true;
						break;
					}
				}
			}
			if (matchFound === false && data.PlatformLineItemPK) {
				const targetValue = JSON.parse(data.PlatformLineItemPK)?.find(({ MasterPlatformID }) => MasterPlatformID == this.props?.campaignMetaData?.PlatformID);
				if (targetValue?.PlatformPK && targetValue.PlatformPK.toLowerCase().includes(searchTerm.toLowerCase())) {
					filteredData.push(data);
				}
			}
		});
		return filteredData;
	};

	clearSearch = () => {
		LineItemDataStore.resetSelectedIO();
		LineItemDataStore.resetSelectedIOID();
		this.setState(
			{
				lineItemData: LineItemDataStore.getData(),
				searchValue: "",
				filteredIO: null,
				success: false,
				successMessage: null,
				advancedFilter: false,
				displayFilter: false
			},
			() => {
				this.gridChanged();
			}
		);
	};

	handleFilter = (filteredData, applyFilter, filterOptions) => {
		if (!document.getElementById("LineItem_find_replace_modal")?.hasAttribute("open")) {
			if (applyFilter === true) {
				this.setState({
					lineItemData: filteredData,
					advancedFilter: true,
					displayFilter: false,
					filterOptions
				});
			} else if (this.state.searchValue !== "") {
				const filteredData = this.returnSearchedValues(this.state.searchValue);
				if (filteredData.length !== 0) {
					this.setState({
						lineItemData: filteredData,
						advancedFilter: false,
						displayFilter: false,
						filteredIO: null,
						filterOptions: []
					});
				} else {
					this.setState({
						lineItemData: LineItemDataStore.getData(),
						advancedFilter: false,
						displayFilter: false,
						filteredIO: null,
						filterOptions: []
					});
				}
			} else {
				this.setState({
					lineItemData: LineItemDataStore.getData(),
					advancedFilter: false,
					displayFilter: false,
					filteredIO: null,
					filterOptions: []
				});
			}
		}
	};

	sendToDV360 = () => {
		const lineItemIDs = [];
		this.state.selectedRows.forEach((row) => {
			lineItemIDs.push(row.LineItemID);
		});
		pushLineItemsToDV360(lineItemIDs)
			.then((response) => {
				showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Line item(s) sent to DV360." timed={5000} />);
			})
			.catch(async (error) => {
				const errorObject = await error.details.json();
				if (errorObject?.Errors) {
					errorObject.Errors.forEach((errorMessage) => {
						showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message={errorMessage} />);
					});
				} else {
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Line item(s) not sent, please review" />);
				}
			});
		this.setState(
			{
				selectedCount: 0,
				singleSelected: false,
				multipleSelected: false,
				loading: true
			},
			() => {
				updateLineItemsSyncStatus(lineItemIDs);
				setTimeout(() => {
					const auditLevelArray = [];
					this.props.auditLevelData.forEach((auditLevel) => {
						auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
					});
					const choices = JSON.parse(JSON.stringify(this.filterChoices));
					let auditLevelChoice = null;
					auditLevelArray.forEach((auditLevel) => {
						if (auditLevel.label === "LineItem") {
							auditLevelChoice = auditLevel;
						}
					});
					if (auditLevelChoice !== null) {
						choices.auditlevel = auditLevelChoice;
						fetchOnlyLineItems(choices, this.parentCampaignUniqueID).catch(() => {
							this.setState({ loading: false });
						});
					}
				}, 20000);
			}
		);
	};

	replaceData = (data, toggleEditing = false) => {
		applyFindReplaceToTable({
			data,
			dataTableApi: this.dataTableApi,
			toggleEditing,
			syncData: (updatedData) => {
				this.setState({ lineItemData: updatedData });
			}
		});
	};

	handleMultiply = (dataWithMultipliedRows) => {
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Line items multiplied successfully." timed={10000} />);
		this.setState({ lineItemData: dataWithMultipliedRows, readOnly: false }, () => {
			this.dataTableApi.current.dataProvider.currentPage = 0;
			retryAtInterval(
				() => this.dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT),
				() => this.dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
			);
		});
	};

	handleDuplicate = (dataWithDuplicates, totalCount) => {
		showToast(
			"workbookToasts",
			<ToastNotification
				type={TOAST_TYPE.SUCCESS}
				message="Line Items have been successfully created in bulk. Confirm all fields in the table have been entered."
				timed={10000}
			/>
		);
		this.setState({ lineItemData: dataWithDuplicates, readOnly: false }, () => {
			this.dataTableApi.current.dataProvider.currentPage = 0;
			retryAtInterval(
				() => this.dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT),
				() => this.dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
			);
		});
	};

	handleRowSelection = (selectedRows) => {
		this.setState({
			selectedRows
		});
	};

	openTraffickingModal = () => {
		this.traffickingModal.triggerOpenClose();
	};

	submitTraffickingSuccess = () => {
		this.setState({ loading: true, singleSelected: false, multipleSelected: false, selectedCount: 0 }, () => {
			this.refetchData(() => {
				this.traffickingModal.triggerOpenClose();
				Modal.hide("AdSet_trafficking_request_modal");
			});
			this.setState({ data: LineItemDataStore.getData(), searchValue: "", filteredPackage: null, loading: false });
		});
	};

	render() {
		const { lineItemConfig, lineItemData, searchValue, advancedFilter, filteredIO } = this.state;

		// let searchTerm = null;
		// if (searchValue !== "" && filteredIO === null) {
		// 	searchTerm = `Search Term: ${searchValue} (${
		// 		lineItemData.filter((row) => {
		// 			return row.LineItemID !== null && row.LineItemID !== undefined;
		// 		}).length
		// 	})`;
		// } else if (filteredIO !== null) {
		// 	searchTerm = `Insertion Order: ${filteredIO} (${
		// 		lineItemData.filter((row) => {
		// 			return row.LineItemID !== null && row.LineItemID !== undefined;
		// 		}).length
		// 	})`;
		// } else if (advancedFilter === true) {
		// 	searchTerm = `Filtered Values (${
		// 		lineItemData.filter((row) => {
		// 			return row.LineItemID !== null && row.LineItemID !== undefined;
		// 		}).length
		// 	})`;
		// }

		const auditLevelID = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "LineItem")?.AuditLevelID;

		const TMEnabled = WorkbookStore.getIsTrafficEnabled();

		return (
			<section className={"tab__container"}>
				{!this.state.isHidden && (
					<>
						{lineItemData && lineItemConfig && (
							<>
								{!this.state.isHidden ? (
									<Table
										ref={this.dataTableApi}
										data={lineItemData}
										config={lineItemConfig}
										hierarchyLevel="LineItem"
										vanityName="Line Item"
										metaData={this.props.campaignMetaData}
										// updateSelected={this.numberSelected}
										updateSelected={this.handleRowSelection} // Need to eventually incorporate all the logic from numberSelected function
										refetchData={this.refetchData}
										search={this.state.search}
										onSearch={(searchValue) => {
											this.setState({ search: searchValue });
										}}
										// Line Item specific props and extra columns
										syncAPI={this.props.campaignMetaData?.SyncIcon === "True"}
										JIRAStatus={TMEnabled}
										extraColumns={this.state.extraColumns}
										auditLevelID={auditLevelID}
										actionBarProps={{
											filtersSideSheet: (
												<FullFiltersSidesheet
													TMEnabled={TMEnabled}
													filterOptions={this.state.filterOptions}
													hierarchyLevel="LineItem"
													ref={this.dataTableApi}
													data={LineItemDataStore.getData()}
													config={lineItemConfig}
													handleFilter={this.handleFilter}
												/>
											),
											search: <Textbox type={"search"} onClear={this.clearSearch} />,
											editButton: (
												<Button
													// this comment exists to prevent eslint from making this unreadable.
													style={{ order: 2 }}
													display={BUTTON_DISPLAY.SECONDARY}
													size={BUTTON_SIZE.SMALL}
													data-tracking-id-alt="open-edit-line-item-details-modal"
												>
													Edit Details
												</Button>
											),
											showEditMode: EDIT_BUTTON_LOCATION.DEFAULT_MODE_ACTIONS,
											defaultModeActions: [
												<Button
													style={{ order: 1 }}
													size={BUTTON_SIZE.SMALL}
													display={BUTTON_DISPLAY.TEXT}
													key="lineitem-find-replace"
													data-tracking-id-alt="open-line-item-find-replace-modal"
													onClick={() => {
														this.findReplaceModal.triggerOpenClose();
													}}
												>
													Find and Replace
												</Button>,
												<Button
													style={{ order: 3 }}
													key="add-lineitem"
													size={BUTTON_SIZE.SMALL}
													onClick={() => {
														this.newLineItemModal.triggerOpenClose(true);
													}}
													data-tracking-id-alt="open-add-line-item-modal"
												>
													Add Line Item
												</Button>
											],
											actions: [
												<Tooltip key="action-clone" title="Clone Line Items" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-copy"
														onClick={() => {
															Modal.show("Line Item_clone_modal");
														}}
														data-tracking-id-alt="open-clone-line-item-modal"
														disabled={draftHLISelected(this.dataTableApi)}
													>
														Clone
													</Button>
												</Tooltip>,
												<Tooltip key="action-multiply" title="Multiply Line Items" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-copy-clipboard"
														onClick={() => {
															Modal.show("Line Item_multiplier");
														}}
														data-tracking-id-alt="open-multiply-line-item-modal"
														disabled={this.state.selectedRows.length > 1 || draftHLISelected(this.dataTableApi)}
													>
														Line Item Multiplier
													</Button>
												</Tooltip>,
												<Tooltip key="edit-lineItem" title="Edit" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														icon="icon-pencil"
														display={BUTTON_DISPLAY.ICON_BORDERED}
														size={BUTTON_SIZE.SMALL}
														disabled={this.state.selectedRows?.length !== 1}
														onClick={() => {
															this.editLineItemModal.triggerOpenClose();
														}}
														data-tracking-id-alt="open-edit-line-item-modal"
													>
														Edit Line Item
													</Button>
												</Tooltip>,
												<Tooltip key="action-delete" title="Delete Line Item" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-trash"
														onClick={this.deleteLineItem}
														data-tracking-id-alt="open-delete-line-item-modal"
														disabled={this.state.selectedRows.length === 0}
													>
														Delete Line Item
													</Button>
												</Tooltip>,
												TMEnabled ? (
													<Tooltip key="action-traffic-request" title="Start traffic request" position={TOOLTIP_POSITION.BOTTOM_START}>
														<Button
															size={BUTTON_SIZE.SMALL}
															display={BUTTON_DISPLAY.ICON_BORDERED}
															icon="icon-play"
															onClick={this.openTraffickingModal}
															disabled={
																!(TMEnabled === true && this.state.selectedRows.every((row) => row.TraffickingPlacementStatusID === "5")) ||
																draftHLISelected(this.dataTableApi)
															}
															data-tracking-id-alt="line-item-open-start-traffic-request-modal"
														>
															Start traffic request
														</Button>
													</Tooltip>
												) : (
													<></>
												)
											]
										}}
									/>
								) : (
									<LoadingIcon />
								)}
							</>
						)}
						{this.state.loading && <LoadingIcon />}

						<NewLineItem
							newLineItem={(ref) => {
								this.newLineItemModal = ref;
							}}
							config={lineItemConfig}
							filters={this.filterChoices}
							metaData={this.props.campaignMetaData}
							updateCounts={this.props.updateCounts}
							auditLevelID={auditLevelID}
						/>
						<EditLineItem
							editLineItem={(ref) => {
								this.editLineItemModal = ref;
							}}
							config={lineItemConfig}
							filters={this.filterChoices}
							data={this.state.selectedRows[0]}
							metaData={this.props.campaignMetaData}
							auditLevelID={auditLevelID}
						/>

						<MultiplierModal
							data={this.state.selectedRows[0]}
							handleMultiply={this.handleMultiply}
							allRows={lineItemData}
							config={lineItemConfig}
							type="Line Item"
							hierarchyLevel="LineItem"
							name="Line Item"
						/>

						<DeleteLineItem
							deletePlatformModal={(ref) => {
								this.deleteLineItemModal = ref;
							}}
							type="Line Item"
							data={this.state.lineItemsToDelete}
							multiple={true}
							deleteType="deleteLineItem"
							hierarchyLevel="LineItem"
							onSubmit={() => {
								// this.props.updateCounts("LineItem");
							}}
							onFailure={this.refetchData}
						>
							<div className="platformListContainer">
								<div className="platformListHeader">
									<span>Description</span>
									<span>Insertion Order</span>
									<span>Site</span>
									<span>Start Date</span>
									<span>End Date</span>
								</div>

								{this.state.selectedRows.map((line, i) => (
									<div className="platformInfoRow" key={`deleteplatformline-${i}`}>
										<span className="platformInfo">{line.PlacementDescription}</span>
										<span className="platformInfo">{line.ParentDescription}</span>
										<span className="platformInfo">{line.InNameSite}</span>
										<span className="platformInfo">{line.StartDate}</span>
										<span className="platformInfo">{line.EndDate}</span>
									</div>
								))}
							</div>
						</DeleteLineItem>
						<DuplicatePlatformModal
							// duplicatePlatformModal={(ref) => {
							// 	this.duplicateLineItem = ref;
							// }}
							type="Line Item"
							config={lineItemConfig}
							data={this.state.selectedRows}
							handleDuplicate={this.handleDuplicate}
							allRows={lineItemData}
						/>
						<FindReplaceModal
							findReplaceModal={(ref) => {
								this.findReplaceModal = ref;
							}}
							type={"LineItem"}
							hierarchyLevel="LineItem"
							config={lineItemConfig}
							data={lineItemData}
							replaceData={this.replaceData}
							tableRef={this.dataTableApi}
						/>

						<TraffickingRequestModal
							traffickingModal={(ref) => {
								this.traffickingModal = ref;
							}}
							selectedRows={this.state.selectedRows}
							campaignMetaData={this.props.campaignMetaData}
							campaignJIRATicket={this.props.campaignJiraTicketExists}
							hierarchyLevel="LineItem"
						/>
					</>
				)}
			</section>
		);
	}
}

export default LegacyLineItemView;
